define(["require", "exports", "jquery", "./context"], function (require, exports, $, context_1) {
    "use strict";
    exports.__esModule = true;
    function setupMobileProductPicture(numberOfPlaceHolders, fabricThumbCount, useFormulaPricing) {
        if (context_1["default"].isMobile()) {
            var pictures = $('a.cloud-zoom-gallery:not(.asset)');
            var show = null;
            if (pictures.length) {
                var slides = $('<div></div>').addClass('defaultPicture');
                pictures.each(function (i, picture) {
                    if (i < fabricThumbCount || i >= numberOfPlaceHolders) {
                        var pictureRel = $(picture).attr('rel');
                        var relData = JSON.parse("{" + pictureRel + "}");
                        $('<img/>').attr('src', relData.smallImage)
                            .appendTo(slides);
                    }
                });
                $('.defaultPicture').replaceWith(slides);
                show = slides;
            }
            else {
                show = $('.photo-viewport');
            }
            if (useFormulaPricing) {
                show = injectLiveViewPrompt(show);
            }
            show.touchSlider({ width: 480, speed: 2, sel: 'img,canvas.scene,.img-box.liveview-prompt' });
            $('div.picture > div.picture > div.picturethumbs').remove();
            pictures.removeAttr('rel').removeClass('cloud-zoom-gallery');
            $('a.cloud-zoom').removeClass('cloud-zoom');
        }
    }
    exports.setupMobileProductPicture = setupMobileProductPicture;
    function injectLiveViewPrompt($show) {
        var $existing = $show.find('>.img-box.liveview-prompt');
        if ($existing.length === 0) {
            var $prompt = $("<div class='img-box liveview-prompt'><label for='liveView' class='icon-camera'><h3>See how it looks in your home</h3></label></div>");
            $prompt.appendTo($show);
        }
        return $show;
    }
    exports.injectLiveViewPrompt = injectLiveViewPrompt;
    function ejectLiveViewScene($show) {
        var $liveScene = $show.find('canvas[zoomId="10-customScene"]').parent();
        if ($liveScene.length) {
            var $paging = $show.find('.paging');
            var curIndex = $show.touchSlider('current');
            $paging.touchSlider('dec');
            $liveScene.appendTo($('#customerSceneBox'));
            $paging.touchSlider('current', curIndex - 1);
        }
        return $show;
    }
    exports.ejectLiveViewScene = ejectLiveViewScene;
    function injectLiveViewScene($show) {
        var children = $('#customerSceneBox').children();
        var childrenCount = children.length;
        if (childrenCount > 0) {
            $show.find('.paging').touchSlider('inc');
            children.find('canvas').toggleClass('scene', true);
            children.insertAfter($show.find('.scene:last').parent());
        }
        return $show.find('.scene:last');
    }
    exports.injectLiveViewScene = injectLiveViewScene;
    function setupMobileAssetPicker(assetLinks, assetClass, $before, isNewDesign, onChange) {
        var $outterDiv = $('<div></div>').addClass('mobile-asset-picker').addClass(assetClass);
        var $div = $('<div></div>').addClass('defaultPicture');
        assetLinks.each(function (i, fabric) {
            var $fabric = $(fabric);
            var $img = $fabric.find('img');
            $('<img/>').attr('src', $fabric.attr('href'))
                .data('slide_title', $fabric.find('.asset-name').text())
                .data('asset_id', $img.data('asset_id'))
                .data('asset_link', $img.data('asset_link'))
                .data('picture_id', $img.data('picture_id'))
                .attr('title', $img.attr('title') || $fabric.text())
                .appendTo($div);
        });
        $outterDiv.insertBefore($before);
        var isSelected = !isNewDesign;
        var curIndex = assetLinks.index(assetLinks.filter('.selected'));
        if (curIndex < 0) {
            curIndex = 0;
            isSelected = false;
        }
        $div.appendTo($outterDiv).touchSlider({ width: 200, speed: 2, gutter: 10, onCurrentChange: onChange }).touchSlider('current', curIndex);
        $div.closest('.photoshow').toggleClass('small');
        var $uploader = assetLinks.filter('.upload-asset');
        if ($uploader.length) {
            $div.find('img[src="#"]').replaceWith($uploader);
        }
        else {
            var $badImage = $div.find('img[src="#"]');
            if ($badImage.length) {
                $('<div></div>').append($('<div class="no-select"></div>').text($badImage.attr('title'))).appendTo($div);
                $badImage.parent().remove();
                if (!isSelected) {
                    $div.find('> div:first-child').toggleClass('current', true);
                }
                else {
                    var newIndex = curIndex > 0 ? curIndex - 1 : assetLinks.length - 1;
                    $div.touchSlider('current', newIndex);
                }
            }
        }
        return $div;
    }
    function setupCustomizeFormForMobile(isNewDesign, allowEdit, getWindowStylePicture) {
        if (context_1["default"].isMobile()) {
            var $anchor = $('.customize-form > div.product-details-info');
            $('#customproductName').insertBefore($anchor);
            $('<hr/>').insertBefore($anchor);
            var $price = $('.price-spec');
            $price.insertBefore($anchor);
            $('<hr/>').insertBefore($anchor);
            var windowStyles = allowEdit ? $('.window-spec a.asset, .window-spec a.upload-asset') : $('.window-spec a.asset.selected');
            setupMobileAssetPicker(windowStyles, 'window-asset', $anchor, isNewDesign, function () {
                var mpicts = getWindowStylePicture();
                $('img.measurement-guide').toggleClass('hidden', false).prop('src', mpicts.details);
            });
            $('<hr/>').insertBefore($anchor);
            var styles = allowEdit ? $('.style-spec a.asset') : $('.style-spec a.asset.selected');
            setupMobileAssetPicker(styles, 'style-asset', $anchor, isNewDesign);
            $('<hr/>').insertBefore($anchor);
            var panels = allowEdit ? $('.panel-spec a.asset') : $('.panel-spec a.asset.selected');
            setupMobileAssetPicker(panels, 'panel-asset', $anchor, isNewDesign);
            $('<hr/>').insertBefore($anchor);
            var fabrics = allowEdit ? $('.fabric-spec .asset-box a.asset') : $('.fabric-spec a.asset.selected');
            setupMobileAssetPicker(fabrics, 'fabric-asset', $anchor, isNewDesign);
            $('<hr/>').insertBefore($anchor);
            $('.fabric-spec').remove();
            $('.fabric-section.dialog').remove();
            $('.window-size-spec').insertBefore($anchor);
            $('<hr/>').insertBefore($anchor);
            $('.valance-size-spec').insertBefore($anchor);
            $('<hr/>').insertBefore($anchor);
            $('.panel-size-spec').insertBefore($anchor);
            $('<hr/>').insertBefore($anchor);
            $('.comment-section').insertBefore($anchor);
            $('.defaultPicture.customize-form-main').remove();
            $('.product-details-info, button.next-section').remove();
        }
    }
    exports.setupCustomizeFormForMobile = setupCustomizeFormForMobile;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/mobileProductPictures.js
// module id = 71
// module chunks = 0